import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Loading from "../Loading/Loading";
import { resetCode } from "../../actions";

class Reset extends PureComponent {
  componentWillMount() {
    const { resetCode } = this.props;
    resetCode();
  }

  render() {
    const { code } = this.props;
    if (!code) {
      const to = `/politicus${
        this.props &&
        this.props.match &&
        this.props.match.params &&
        this.props.match.params.wrongcode
          ? "?wrongcode=1"
          : ""
      }`;

      return <Redirect to={to} />;
    }

    return <Loading />;
  }
}

const mapStateToProps = state => {
  return {
    code: state.code
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetCode: () => {
      dispatch(resetCode());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Reset);



// WEBPACK FOOTER //
// ./src/components/Reset/Reset.js